import React from 'react';
import img1 from './asset/推送人群.png';
import img2 from './asset/app批量选择.png';
import img3 from './asset/快手小店.png';
import './feature.less';
import { CalendarDot } from '@icon-park/react';

function IssueTime(props: { children: React.ReactNode }) {
    return (
        <span className="issue-time">
            <CalendarDot theme="outline" size="16" fill="#797979" />
            上线时间：{props.children}
        </span>
    );
}

export function Feature() {
    return (
        <div className="md-feature">
            <h1>功能动态</h1>
            <h2 id="上线公告">【上线公告】</h2>
            <h3 id="磁力万象2.0正式上线">磁力万象2.0正式上线</h3>
            <p>
                <strong>核心亮点一：新增标签专区</strong>
            </p>
            <p>
                通过收口标签选取界面，直接展示更多的标签，精准定向目标人群；同时新建人群流程缩短，弹窗式设计避免操作路径过长，由标签专区即可直接进行人群包创建，助力在投放前优化人群构建效率。
            </p>
            <p>
                <strong>核心亮点二：运算人群升级</strong>
            </p>
            <p>
                支持在人群管理界面进行已有人群与所有标签之间的交集/并集/差集计算，满足广告主创建多样人群包的需求，减少账户内的人群包数量。
            </p>
            <p>
                <strong>核心亮点三：新增行业精选</strong>
            </p>
            <p>
                包括行业最新上线和行业专属推荐两个模块，致力于解决广告主人群包挑选困难的问题，目前已上线游戏行业、教育行业和资讯行业等18个一级行业。
            </p>
            <p>行业最新上线：近60天新上线人群包，方便广告主了解人群包上线动态和新的人群定向属性;</p>
            <p>
                行业专属推荐：根据账户行业营销目标和历史人群包使用效果数据，通过算法模型推荐行业专属定制的人群包。
            </p>
            <h3 id="人群包id唯一并增加人群包重复校验功能">人群包ID唯一并增加人群包重复校验功能</h3>
            <p>
                <IssueTime>2020.09.10</IssueTime>
            </p>
            <p>
                <strong>一、需求背景</strong>
            </p>
            <p>
                为了更好地规范跨账户操作，帮助广告主更方便地查看人群数据、查找并管理推送人群包路径，DMP本次更新固定了人群包ID保持不变，并增加了人群包重复校验功能，减少重复推送的情况。
            </p>
            <p>
                <strong>二、具体介绍</strong>
            </p>
            <p>1、功能简述</p>
            <ul>
                <li>
                    人群包id唯一，保持不变。例如：A包（id:
                    67891）从账户1上传，由账户1推送给账户2/3/4，跨账户推送后显示人群包id仍为67891。
                </li>
                <li>
                    跨账户推送时增加校验人群包id, 如输入的账户中已有同一个包id, 则提示不可推送。
                </li>
            </ul>
            <p>2、操作介绍</p>
            <p> a. 选择需推送的相应人群包，可进行批量操作推送。</p>
            <p>​ b. 输入账户ID。显示已选人群包数量以及推送账户数量。</p>
            <p>​ 不可推送账户将被置灰并显示无法推送原因（格式错误，超出推送范围等）。</p>
            <p>
                <img src={img1} alt="推送人群" />
            </p>
            <p>
                <strong>三、FAQ/注意事项</strong>
            </p>
            <ol>
                <li>
                    功能新上线后新上传的人群包，本次更新优化了底层ID与表层ID均唯一；针对历史人群包，表层ID暂不做改变，底层ID逻辑唯一（即同一人群包表层ID不同，但仍会在校验时认定为同一人群包）。
                </li>
                <li>推送与批量推送时均会自动启动校验功能。</li>
            </ol>
            <h3 id="人群包同时上线数量从4个升级为6个">人群包同时上线数量从4个升级为6个</h3>
            <p>
                <IssueTime>2020.09.10</IssueTime>
            </p>
            <p>
                <strong>需求介绍</strong>
            </p>
            <p>
                DMP在广告主效果投放中十分重要，尤其是上传自有人群进行拉新或拉活营销。平台性能支持同一个账户同时上线4个人群，已经不能满足广告主日益增长的需要。
                为了提升广告主操作效率，DMP本次重点提升资源和性能，将人群包同时上线数量进行从4个提升至6个，极大减少客户等待人群上线到投放的时间，提升投放效率，
                更高效地利用DMP人群进行精准投放。
            </p>
            <h3 id="新建人群-应用安装覆盖至top-10000-并支持批量添加功能">
                新建人群-应用安装覆盖至TOP 10000 并支持批量添加功能
            </h3>
            <p>
                <IssueTime>2020.09.10</IssueTime>
            </p>
            <p>
                <strong>一、需求背景</strong>
            </p>
            <p>
                为了更好的满足广告主根据用户对移动应用安装行为做精细化投放，DMP本次更新对应用安装行为标签进行二期优化，助力精准定向人群。
            </p>
            <p>
                <strong>二、具体介绍</strong>
            </p>
            <p>1、功能简述</p>
            <ul>
                <li>
                    广告主可在新建人群包中，用户行为数据下移动应用安装，选择特定的应用分类或名称进行人群打包。
                </li>
                <li>
                    本次二期优化增加了APP数目，从TOP5000扩展为TOP10000。同时，增加了批量选择功能，提升使用效率。
                </li>
            </ul>
            <p>2、操作介绍</p>
            <p>【入口】</p>
            <p>新建人群包-用户行为数据-应用维度-按应用名称</p>
            <p>
                <img src={img2} alt="app批量选择" />
            </p>
            <p>【操作】</p>
            <p>a. 按要求手动输入添加应用名称，每行一个</p>
            <p>b. 点击确定后，弹窗提示成功应用名称数量、失败应用数量及具体名称。</p>
            <p>c. 关闭弹窗后，成功应用名称已添加，并显示预估人群覆盖数量。</p>
            <p>
                <strong>三、FAQ/注意事项</strong>
            </p>
            <ol>
                <li>列表中移动应用覆盖人群更新机制为T+1。</li>
            </ol>
            <h3 id="新建人群快手小店增加三级类目">新建人群快手小店增加三级类目</h3>
            <p>
                <IssueTime>2020.08.12</IssueTime>
            </p>
            <p>
                <strong>一、需求背景</strong>
            </p>
            <p>
                为了更好的帮助广告主根据用户对商品细分需求做精细化投放，DMP本次更新使得新建人群包快手小店定向类目从二级升级到三级类目，助力精准定向人群。
            </p>
            <p>
                <strong>二、具体介绍</strong>
            </p>
            <p>1、功能简述</p>
            <p>
                可在新建人群包中，用户行为数据下快手小店类型，选择三级细分类目对人群进行打包创建。
            </p>
            <p>2、功能优势</p>
            <p>
                更加细化快手小店品类，更精准地匹配定向与业务推广的商品，有利于（尤其是中小）广告主提升人群定向精准度。
            </p>
            <p>3、操作介绍</p>
            <p>【快手小店】</p>
            <p>入口：DMP-新建人群-用户行为数据-快手小店</p>
            <p>操作界面：</p>
            <p>
                <img src={img3} alt="快手小店" />
            </p>
            <h3 id="新建人群增加用户年龄维度打包">新建人群增加用户年龄维度打包</h3>
            <p>
                <IssueTime>2020.08.07</IssueTime>
            </p>
            <p>
                <strong>一、需求背景</strong>
            </p>
            <p>
                为了补全DMP新建人群包打包维度，DMP本次更新为新建人群包模块增添筛选用户年龄纬度，更精准定向人群。
            </p>
            <p>
                <strong>二、具体介绍</strong>
            </p>
            <p>1、功能简述</p>
            <p>可在新建人群包中选择不同年龄段人群进行打包。</p>
            <p>2、功能优势</p>
            <p>对于有用户年龄需求的客户来说，可选择特定年龄段人群，提升人群定向精准度。</p>
            <h3 id="上传人群支持增量更新">上传人群支持增量更新</h3>
            <p>
                <IssueTime>2020.08.06</IssueTime>
            </p>
            <p>
                <strong>一、需求背景</strong>
            </p>
            <p>
                为了使广告主的上传人群包能够持续为广告优化产生效果，加强上传人群包内的数据时效性和有效性，DMP本次支持人群包模块追加更新的能力，为精细化运营助力。
            </p>
            <p>
                <strong>二、具体介绍</strong>
            </p>
            <p>1、功能简述</p>
            <p>可通过Marketing API接口对已有人群包进行追加增量，以更新相应数据。</p>
            <p>常见使用场景：</p>
            <ul>
                <li>客户可以通过该功能对指定人群包数据进行增加更新，从而达到精细化定向；</li>
                <li>客户可将更丰富的转化数据回传至DMP，用于算法侧融入模型，提升投放转化效果。</li>
            </ul>
            <p>2、操作介绍</p>
            <p>【增量更新】</p>
            <p>
                可通过Marketing
                API实现对定投人群包数据增加或更新，可将新文件中的数据追加补充到已有人群包中。
            </p>
            <p>Marketing API申请流程及各功能模块对接文档：</p>
            <p>
                <a
                    href="https://yiqixie.com/d/home/fcADEXQxHKDh9uB1EphK0SxQ-"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://yiqixie.com/d/home/fcADEXQxHKDh9uB1EphK0SxQ-
                </a>
            </p>
            <p>Marketing API-人群管理模块详细功能介绍（Part 9）：</p>
            <p>
                <a
                    href="https://yiqixie.com/d/home/fcAAfm9OQj5OeEBd9TB2gtxvD#section=h.b0gblnw2uzbm"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://yiqixie.com/d/home/fcAAfm9OQj5OeEBd9TB2gtxvD#section=h.b0gblnw2uzbm
                </a>
            </p>
            <p>
                <strong>三、注意事项</strong>
            </p>
            <ol>
                <li>
                    仅人群包类型为“上传人群”的人群包支持更新，更新文件的要求同DMP后台上传人群包界面的要求；且更新时，接口中的type字段，需要与原包保持一致，否则接口返回信息报错。
                </li>
                <li>
                    人群包更新后，规则人群包的子包不做更新。例如：a包和b包进行一定运算操作，
                    形成c包。 a/b是父包，c是子包。 即使a/b数据更新，
                    子包不会同步更新，需要重新人工操作进行运算。
                </li>
                <li>人群包更新后，推送至其他账户的相关人群包自动同步更新。</li>
            </ol>
            <h3 id="dmp-人群包推送相关功能更新">DMP-人群包推送相关功能更新</h3>
            <p>
                <IssueTime>2020.07.24</IssueTime>
            </p>
            <p>
                <strong>一、需求背景</strong>
            </p>
            <p>
                为了帮助广告主更准确的了解并使用DMP的推送功能，降低操作门槛，保证广告主数据安全和明确传播途径，DMP于7月24日对人群包推送模块相关功能进行了更新并正式上线。
            </p>
            <p>
                <strong>二、具体介绍</strong>
            </p>
            <p>1、功能简述</p>
            <p>
                在人群包管理界面，区分规范“上线”与“推送”操作，人群包详情页面显示“上线与推送记录”，并针对一些不可用操作进行弹窗提示。
            </p>
            <p>2、功能优势</p>
            <p>对人群包的操作使用更加严谨规范，便于广告主操作，同时保证广告主资产安全。</p>
            <p>3、操作介绍</p>
            <p>
                <strong>【上线】</strong>
            </p>
            <p>
                <strong>
                    1）上线：指的是人群从发布至快手广告系统当中可以被投放使用。人群上线后即可在所属账户投放端选择使用，或推送给其他账户。
                </strong>
            </p>
            <p>
                <strong>2）人群包状态新增“上线中”、“已上线”、“上线失败”</strong>
                ：对应之前的“推送中”、“已推送”、“推送失败”，同一账户最多允许同时有4个人群包为“上线中”的状态。
            </p>
            <p>
                <strong>【推送】</strong>
            </p>
            <p>
                <strong>
                    1）“推送”代表推送至其他同主体账户使用：仅当人群包状态为“已上线”时，在投放平台可见且允许人群包进行“推送”或“批量推送”操作。
                </strong>
            </p>
            <p>
                2）非账户自有人群包不允许跨账户推送：即人群包不再支持二次推送，保证广告主人群包资产安全。
            </p>
            <p>
                <strong>【详情】</strong>
            </p>
            <p>
                <strong>a. 人群包详情新增“来源”和“上线与推送记录”</strong>
                ，显示人群包来源，以及推送给了哪些账户。
            </p>
            <p>
                <strong>【操作弹窗】</strong>
            </p>
            <p>
                <strong>a. 新增多种人群包操作信息提示弹窗</strong>
                ，部分人群包会一定的操作限制，相关操作按钮会置灰，鼠标移至上方时，提示不可操作原因，帮助广告主根据相关提示对人群包进行相应操作，提升对平台产品的理解。
            </p>
            <p>
                <strong>三、FAQ/注意事项</strong>
            </p>
            <ol>
                <li>
                    为保证广告主自有数据使用的安全性，限制人群包进行二次推送，广告主可根据人群包详情页面的“来源”信息，进入相应的账户操作；
                </li>
                <li>
                    “上线与推送记录”中，上线记录为功能开发上线后新增信息，历史人群包的上线记录未追溯，如果广告主未看到创建时间早于2020年7月21号前的人群包的上线记录，非异常现象。
                </li>
            </ol>
            <h3 id="人群管理界面批量操作功能上线">人群管理界面批量操作功能上线</h3>
            <p>
                <IssueTime>2020.07.15</IssueTime>
            </p>
            <p>
                <strong>一、需求背景</strong>
            </p>
            <p>为了帮助广告主更高效地管理DMP中的人群包，提升操作效率，DMP上线了批量操作功能。</p>
            <p>
                <strong>二、具体介绍</strong>
            </p>
            <p>
                <strong>1、功能简述</strong>
            </p>
            <p>
                在DMP人群管理界面，可进行人群包的“批量推送”和“批量删除”操作，对已有人群包实现高效管理，提升操作效率。
            </p>
            <p>
                <strong>2、操作介绍</strong>
            </p>
            <p>​ 在“人群管理”界面新增“批量推送”和“批量删除”入口。</p>
            <p>
                <strong>【批量推送】</strong>
            </p>
            <p>
                a.点击“批量推送”时，可在页面进行多选（不可选择的人群包会置灰），支持跨页选择人群包，右上方显示已选人群包数量，选择完成后可点击“确认推送”;
            </p>
            <p>
                b.点击“确认推送”时，会弹出“账户ID输入框”，需要按格式要求输入和当前账户营业执照相同的账户ID，营业执照信息可以在“投放平台-账户-账户资质”查看。
            </p>
            <p>
                <strong>【批量删除】</strong>
            </p>
            <p>
                点击“批量删除”时，可在页面进行多选（不可选择的人群包会置灰），支持跨页选择人群包，右上方显示已选人群包数量，选择完成后可点击“确认删除”，点击后直接批量删除成功。
            </p>
            <p>
                <strong>三、注意事项</strong>
            </p>
            <p>
                1.“批量操作”仅用于跨账户推送，输入账户ID时，如果包含了营业执照与当前账户不一致的账户ID，仅会在营业执照一致的账户成功推送；
            </p>
            <p>
                2.“批量删除”功能，点击“确认删除”后直接删除，暂无弹窗提醒且不可恢复，请广告主谨慎操作。
            </p>
        </div>
    );
}
